define("shared/helpers/linkify-text", ["exports", "@ember/component/helper", "@ember/template", "dompurify", "shared/utils/escape-html", "shared/utils/find-link-segments"], function (_exports, _helper, _template, _dompurify, _escapeHtml, _findLinkSegments) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/template",0,"dompurify",0,"shared/utils/escape-html",0,"shared/utils/find-link-segments"eaimeta@70e063a35619d71f
  /**
   * Renders URLs inside a plain-text string as anchors that open in a new tab. The link text
   * is whatever was typed; only the href gets a scheme filled in. Mirrors the rules of Later
   * Influence's `linkifyText` util so both sides of a concept submission behave the same way.
   * See `shared/utils/find-link-segments` for those rules, shared with `linkify-html`.
   *
   * The input is escaped before the anchors are spliced in, and the result runs through
   * DOMPurify, because the return value is `htmlSafe` and the text is user-authored.
   */
  const linkifyTextHelperFn = _ref => {
    let [text] = _ref;
    const html = (0, _findLinkSegments.default)(text ?? '').map(segment => {
      if (segment.kind === 'text') {
        return (0, _escapeHtml.default)(segment.value);
      }
      const attrs = `href="${(0, _escapeHtml.default)(segment.href)}" rel="noopener noreferrer" target="_blank"`;
      return `<a ${attrs}>${(0, _escapeHtml.default)(segment.text)}</a>`;
    }).join('');
    const sanitizedHtml = _dompurify.default.sanitize(html, {
      ALLOWED_ATTR: ['href', 'rel', 'target'],
      ALLOWED_TAGS: ['a']
    });
    return (0, _template.htmlSafe)(sanitizedHtml);
  };
  const linkifyTextHelper = (0, _helper.helper)(linkifyTextHelperFn);
  var _default = _exports.default = linkifyTextHelper;
});